// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quantityBox .error{left:0;right:0}", "",{"version":3,"sources":["webpack://./src/components/OrderCartButton.vue"],"names":[],"mappings":"AAEE,oBACE,MAAA,CACA,OADJ","sourcesContent":["\n.quantityBox {\n  .error {\n    left: 0;\n    right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
